import { useEffect, useRef, useState } from 'react';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import { post } from '../../Auths/AuthToken';
import { format } from 'date-fns';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import AlertDialog from '../../../Utilities/AlertDialog';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../../redux/slices/appSlice';
import setUiMessage from '../../../Utilities/Tostify';

function AppProcessingDropDown({
  hideShow,
  data,
  handleSpecAppStatusPopup,
  setHideShow,
}) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const [revertPromt, setRevertPromt] = useState(false);
  const [alertBoxNcv, setAlertBoxNcv] = useState(false);
  const [alertBox, setAlertBox] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setHideShow && setHideShow(true);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setHideShow, hideShow, ref]);

  const handleRevert = (flag, data) => {
    if (
      data?.start_time &&
      data?.max_visit_date &&
      Date.parse(format(new Date(data?.start_time), DEFAULT_DATE_FORMATE)) <
        Date.parse(format(new Date(data?.max_visit_date), DEFAULT_DATE_FORMATE))
    ) {
      setAlertBoxNcv(true);
    } else {
      setRevertPromt(true);
      setSucPrams(flag);
    }
    if (flag !== 'ncv') {
      if (
        Date.parse(format(new Date(data?.start_time), DEFAULT_DATE_FORMATE)) <
          Date.parse(
            format(new Date(data?.max_visit_date), DEFAULT_DATE_FORMATE)
          ) &&
        data?.soap_flag === '3'
      ) {
        setAlertBox(true);
      } else {
        setRevertPromt(true);
        setSucPrams(flag);
      }
    }
  };

  const handleRevertConfirm = async (flag) => {
    if (flag === 'ncv') {
      try {
        const response = await post(
          'api/appointment/appointment/revertStatusForNotCrtVisit',
          {
            appointmentId: data?.appointmentId,
            currentStatusId: data?.appointment_status,
            currentStatusAutoIncId: data?.appPointmentStatusAutoIncrId,
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          dispatch(handleGlobalReload(!globalReload));
          setRevertPromt(false);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    } else {
      try {
        const response = await post(
          'api/appointment/appointment/revertStatus',
          {
            appointmentId: data?.appointmentId,
            currentStatusId: data?.appointment_status,
            currentStatusAutoIncId: data?.appPointmentStatusAutoIncrId,
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          dispatch(handleGlobalReload(!globalReload));
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }
  };

  return (
    <>
      <div
        ref={ref}
        className={
          hideShow === true ? 'apsch-actn-contnr hide' : 'apsch-actn-contnr'
        }
      >
        {data?.create_visit_y_n === '1' || data.treatment_plan_mode === '1' ? (
          <ul className="rc-li-con">
            {data?.appointment_status !== '1' &&
            data?.appointment_status !== '2' &&
            data?.appointment_status !== '3' ? (
              <>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stCheckinTitle}
                    onClick={() => handleSpecAppStatusPopup(11)}
                  >
                    Check-In
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[5]}
                    {data?.processStatus?.individualProcessDone[5]}
                  </span>
                </li>
                {data.treatment_plan_mode === '1' ? (
                  <li className="rc-pt-lst">
                    <span
                      className="rc-pt-nm"
                      title={data?.processStatus?.stCounselTitle}
                      onClick={() => handleSpecAppStatusPopup(5)}
                    >
                      {data?.processStatus?.stCounselTitle}
                    </span>
                    <span className="rc-pt-ifo">
                      {data?.processStatus?.statusInProcess[16]}
                      {data?.processStatus?.individualProcessDone[16]}
                    </span>
                  </li>
                ) : (
                  <li className="rc-pt-lst">
                    <span
                      className="rc-pt-nm"
                      title={data?.processStatus?.stCounselTitle}
                      onClick={() => handleSpecAppStatusPopup(5)}
                    >
                      {data?.processStatus?.stCounselTitle}
                    </span>
                    <span className="rc-pt-ifo">
                      {data?.processStatus?.statusInProcess[16]}
                      {data?.processStatus?.individualProcessDone[16]}
                    </span>
                  </li>
                )}
                {/* <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stCounselTitle}
                    onClick={() => handleSpecAppStatusPopup(5)}
                  >
                    Counseling
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[16]}
                    {data?.processStatus?.individualProcessDone[16]}
                  </span>
                </li> */}
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stcheckOutTitle}
                    onClick={() => handleSpecAppStatusPopup(16)}
                  >
                    Check-out
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[9]}
                    {data?.processStatus?.individualProcessDone[9]}{' '}
                  </span>
                </li>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    onClick={() => {
                      if (data.treatment_plan_mode === '1') {
                        return handleRevert('', data);
                      } else {
                        return handleRevert('ncv', data);
                      }
                    }}
                  >
                    Revert
                  </span>
                </li>
              </>
            ) : (
              <li className="rc-pt-lst">
                <span
                  className="rc-pt-nm"
                  onClick={() => {
                    if (data.treatment_plan_mode === '1') {
                      return handleRevert('', data);
                    } else {
                      return handleRevert('ncv', data);
                    }
                  }}
                >
                  Revert
                </span>
              </li>
            )}
          </ul>
        ) : (
          <ul className="rc-li-con">
            {data?.appointment_status !== '1' &&
            data?.appointment_status !== '2' ? (
              <>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stCheckinTitle}
                    onClick={() => handleSpecAppStatusPopup(11)}
                  >
                    Check-in
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[5]}
                    {data?.processStatus?.individualProcessDone[5]}
                  </span>
                </li>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stScreenTitle}
                    onClick={() => handleSpecAppStatusPopup(5)}
                  >
                    Screening
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[6]}
                    {data?.processStatus?.individualProcessDone[6]}
                  </span>
                </li>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stExamineTitle}
                    onClick={() => handleSpecAppStatusPopup(6)}
                  >
                    Examine
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[7]}
                    {data?.processStatus?.individualProcessDone[7]}
                  </span>
                </li>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stcheckOutTitle}
                    onClick={() => handleSpecAppStatusPopup(7)}
                  >
                    Check-out
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[9]}
                    {data?.processStatus?.individualProcessDone[9]}{' '}
                  </span>
                </li>
                <li className="rc-pt-lst">
                  <span
                    className="rc-pt-nm"
                    title={data?.processStatus?.stPnTitle}
                    onClick={() => handleSpecAppStatusPopup(9)}
                  >
                    Progress note
                  </span>
                  <span className="rc-pt-ifo">
                    {data?.processStatus?.statusInProcess[8]}
                    {data?.processStatus?.individualProcessDone[8]}{' '}
                  </span>
                </li>
                <li
                  className="rc-pt-lst"
                  onClick={() => handleRevert('', data)}
                >
                  <span className="rc-pt-nm">Revert</span>
                </li>
              </>
            ) : (
              <li className="rc-pt-lst" onClick={() => handleRevert('', data)}>
                <span className="rc-pt-nm">Revert</span>
              </li>
            )}
          </ul>
        )}
      </div>
      {revertPromt && (
        <ConfirmDialog
          title={`Revert ${data?.patient_name}`}
          bodytext={`Do You want to go back to "${data?.status_name}" ?`}
          closeDialog={() => setRevertPromt(false)}
          successDialog={handleRevertConfirm}
          sucPrams={sucPrams}
        />
      )}

      {alertBoxNcv && (
        <AlertDialog
          title={`Revert ${data?.patient_name}`}
          bodytext={`You can't revert this appointment because you can only revert the latest visit.`}
          successDialog={() => setAlertBoxNcv(false)}
        />
      )}
      {alertBox && (
        <AlertDialog
          title={`Revert ${data?.patient_name}`}
          bodytext={`You can't revert this appointment because this visit has signed note.`}
          successDialog={() => setAlertBox(false)}
        />
      )}
    </>
  );
}

export default AppProcessingDropDown;
